(function () {
  const config = window.FreedomDiscountConfig || {};
  const CODE = (config.code || 'FREEDOM').toUpperCase();
  const START = config.startDate || '2026-08-13';
  const END = config.endDate || '2026-08-18';
  const TIMEZONE = config.timezone || null;
  function getDateString(date) {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };
    if (TIMEZONE) options.timeZone = TIMEZONE;

    return new Intl.DateTimeFormat('en-CA', options).format(date);
  }

  function isWithinWindow() {
    try {
      const today = getDateString(new Date());
      return today >= START && today <= END;
    } catch (e) {
      return false;
    }
  }

  function getModal() {
    return document.getElementById('FreedomDiscountModal');
  }

  function openModal() {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('freedom-modal-open');
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('freedom-modal-open');
  }

  function applyDiscount(code) {
    const redirect = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + redirect;
  }

  function handleApply(rawCode) {
    const code = (rawCode || '').trim();
    if (!code) return;

    if (code.toUpperCase() === CODE && !isWithinWindow()) {
      openModal();
      return;
    }

    applyDiscount(code);
  }

  function bindForms() {
    document.querySelectorAll('[data-freedom-discount-form]').forEach(function (form) {
      if (form.dataset.freedomBound === 'true') return;
      form.dataset.freedomBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        const input = form.querySelector('[data-freedom-discount-input]');
        handleApply(input ? input.value : '');
      });
    });
  }

  function init() {
    bindForms();

    document.querySelectorAll('[data-freedom-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    const modal = getModal();
    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart drawer re-renders content; re-bind after DOM updates.
  document.addEventListener('cart:updated', bindForms);
  const observer = new MutationObserver(function () {
    bindForms();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
